import React from 'react';

import { Text } from '@betterment/samba-react';
import { Box, Flex, ModalContent, ModalOverlay, Typist } from '@betterment/style-closet-react';
import styled from '@emotion/styled';
import VisuallyHidden from '@reach/visually-hidden';

import AnimatedCheckmark from './AnimatedCheckmark';

const Content = styled(ModalContent)`
  &&& {
    max-width: none;
    width: 100%;
  }
`;

export interface SuccessOverlayProps {
  message: string;
  onCompletion?: () => void;
}

const SuccessOverlay: React.FC<React.PropsWithChildren<SuccessOverlayProps>> = ({ message, onCompletion }) => {
  return (
    <ModalOverlay>
      <Content my="0" mx="0" aria-label={message}>
        <Flex p="4" height="100vh" alignItems="center" justifyContent="center" flexDirection="column" bg="bmtNavy">
          <Box mb="8">
            <AnimatedCheckmark />
          </Box>
          <VisuallyHidden>
            <Text>{message}</Text>
          </VisuallyHidden>
          <Typist onTypingDone={onCompletion} startDelay={500}>
            <Text
              color="text.inverse"
              css={{
                fontWeight: 'bold',
                lineHeight: 'lineHeight.100',
                fontSize: 'fontSize.300',
              }}
            >
              {message}
            </Text>
            <Typist.Delay ms={800} />
          </Typist>
        </Flex>
      </Content>
    </ModalOverlay>
  );
};

export default SuccessOverlay;
